// src/config/deliveryPrices.ts

export type TransportType = 'auto' | 'moto' | 'bici' | 'van' | 'light';
export type ServiceType = 'persona' | 'paquete';

interface PriceConfig {
  base: number;
  perKm: number;
}

// Configuración de precios por Tipo de Transporte y Tipo de Servicio
export const DELIVERY_PRICES: Record<TransportType, Record<ServiceType, PriceConfig>> = {
  auto: {
    persona: { base: 600, perKm: 800 },
    paquete: { base: 400, perKm: 600 }
  },
  moto: {
    persona: { base: 400, perKm: 600 },
    paquete: { base: 300, perKm: 500 }
  },
  bici: {
    persona: { base: 200, perKm: 600 },
    paquete: { base: 300, perKm: 500 }
  },
  light: {
    persona: { base: 400, perKm: 600 },
    paquete: { base: 300, perKm: 500 }
  },
  van: {
    persona: { base: 1200, perKm: 1100 },
    paquete: { base: 1000, perKm: 900 }
  }
};

const normalizeTransportType = (transport: string): TransportType => {
  switch (transport) {
    case 'car':
      return 'auto';
    case 'motorcycle':
      return 'moto';
    case 'bike':
      return 'bici';
    default:
      return (DELIVERY_PRICES[transport as TransportType] ? transport : 'auto') as TransportType;
  }
};

/**
 * Obtiene la configuración de precio para una combinación específica
 */
export const getPriceConfig = (transport: string, service: string): PriceConfig => {
  const t = normalizeTransportType(transport);
  const s = (DELIVERY_PRICES[t][service as ServiceType] ? service : 'persona') as ServiceType;
  return DELIVERY_PRICES[t][s];
};
